export default {
  auth_login: '/api/auth/login',
  auth_changeOrganization: '/api/auth/change_organization',
  auth_reauthorize: '/api/auth/reauthorize',
};
